import { defineNuxtPlugin, useRuntimeConfig } from '#app'
import { AwsRum, PageIdFormatEnum} from 'aws-rum-web';
import type { AwsRumConfig } from 'aws-rum-web';

declare global {
  interface Window { __awsRum?: AwsRum }
}

export default defineNuxtPlugin(() => {
  const {
    public: {
        rumAppId,
        rumEnabled,
        rumSampleRate,
        rumEnableXRay,
    }
  } = useRuntimeConfig();

  if (!rumEnabled) return
  if (!rumAppId) return
  if (typeof window === 'undefined') return
  // Avoid duplicate init on HMR / client nav
  if (window.__awsRum) return

  const config: AwsRumConfig = {
    sessionSampleRate: Number.isFinite(rumSampleRate) ? Number(rumSampleRate) : 1,
    endpoint: "https://dataplane.rum.eu-north-1.amazonaws.com",
    telemetries: ['performance', 'errors', 'http'] as const,
    allowCookies: true,
    enableXRay: !!rumEnableXRay,
    signing: false,
    pageIdFormat: PageIdFormatEnum.Path
  }

  try {
    const rum = new AwsRum(
        String(rumAppId),
        '1.0.0',
        'eu-west-1',
        config
    )
    window.__awsRum = rum
    rum.addSessionAttributes({
        "environment": import.meta.env.DEV ? "dev" : "prod",
        "tenant": window.location.hostname.split('.')[0] ?? "unknown"
    });
  } catch (e) {
    // Swallow init errors to avoid breaking the app
    console.warn('RUM init failed:', e)
  }
})
